import React, { useEffect, useState, useContext } from "react";
import { useParams, Link } from "react-router-dom";
import { useHistory } from "react-router";
import firebase from "firebase/app";
import { AuthContext } from "../context/AuthContext";
import getTourById from "../requests/getTourById";
import getGigById from "../requests/getGigById";
import getSalesByGig from "../requests/getSalesByGig";
import updateGigVenueCut from "../requests/updateGigVenueCut";

import GigFinancialDataTable from "./GigFinancialDataTable";
import GigFinancialDataVenueCutForm from "./GigFinancialDataVenueCutForm";

const GigFinancialData = () => {

  const { tourId, gigId } = useParams();
  const history = useHistory();

  const gigInitialState = [{
    date: "",
    venue: "",
    venueCut: 0
  }];

  const { user, setUser } = useContext(AuthContext);
  const [ token, setToken ] = useState("");
  const [ gig, setGig ] = useState(gigInitialState);
  const [ sales, setSales ] = useState([]);
  const [ venueCut, setVenueCut ] = useState("");
  const [ tour, setTour ] = useState({
    name: "",
    gigs: [],
    products: [],
    editors: []
  });

  useEffect(() => {
    firebase.auth().onAuthStateChanged(function(firebaseUser) {
      if (firebaseUser) {
        setUser(firebaseUser);
        firebaseUser.getIdToken().then(token => {
          setToken(token);
        })
      } else {
        history.push("/login");
      }
    });
  }, [history, setUser, user]);

  useEffect(() => {
    if (token) {
      getTourById(token, tourId).then(response => {
        // console.log(response);
        if (!response.data[0].gigs) {
          response.data[0].gigs = [];
        }
        if (!response.data[0].products) {
          response.data[0].products = [];
        }
        setTour(response.data[0]);
      })
    }
  }, [token, tourId]);

  useEffect(() => {
    if (token) {
      getSalesByGig(token, gigId).then(response => {
        if (response.status === 200) {
          setSales(response.data);
        } else {
          setSales([]);
        }
      })
    }
  }, [token, gigId])

  useEffect(() => {
    if (token) {
      getGigById(token, tourId, gigId).then((response) => {
        setGig(response.data[0]);
        setVenueCut(response.data[0].venueCut);
      })
    }
  }, [gigId, token, tourId]);

  const unhideVenueCutUpdateForm = () => {
    const updateForm = document.getElementById("updateVenueCut");
    updateForm.classList.remove("hidden");
  }

  const handleVenueCutFieldChange = (event) => {
    setVenueCut(event.target.value);
  }

  const handleVenueCutUpdate = (event) => {
    event.preventDefault();
    if (token) {
      updateGigVenueCut(token, tourId, gigId, venueCut).then(response => {
        console.log(response);
        if (response.status === 200) {
          const updateForm = document.getElementById("updateVenueCut");
          updateForm.classList.add("hidden");
        }
      });
    }
  };

  const gigDate = new Date(gig.date).toDateString();
  if (!user) return (<></>);
  const userIsEditor = tour.editors.includes(user.uid);

  return (
    <div className="container">
      <Link className="nav-link" to={`/tour/${tourId}`}>Tour index page</Link>
      <h2 className="heading">Gig financial summary</h2>
      <h3><span className="gig-identifier">venue:</span> {gig.venue}</h3>
      <h3><span className="gig-identifier">date:</span> {gigDate}</h3>
      <section>
        <GigFinancialDataTable
          token={token}
          tourId={tourId}
          gigId={gigId}
          venueCut={venueCut}
          sales={sales}
          unhideVenueCutUpdateForm={unhideVenueCutUpdateForm}
          userIsEditor={userIsEditor}
        />
      </section>

      {
        userIsEditor &&
        (
          <section>
            <GigFinancialDataVenueCutForm
              venueCut={venueCut}
              handleVenueCutUpdate={handleVenueCutUpdate}
              handleVenueCutFieldChange={handleVenueCutFieldChange}
            />
          </section>
        )
      }
    </div>
  );

};

export default GigFinancialData;